export default "__VITE_ASSET__B8_PwuIc__"